import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess6020BuchenStatus: 'idle',
    startProcess6020BuchenError: undefined as any,
    loadUserParamsProcess6020BuchenStatus: 'idle',
    loadUserParamsProcess6020BuchenError: undefined as any,

    process6020BuchenList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess6020Buchen = createAsyncThunk('process6020BuchenSlice/startProcess6020Buchen', async ({ process6020Buchen }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess6020Buchen/`,
        prepareData(process6020Buchen),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess6020BuchenStatus } = getState().process6020BuchenSlice
        return startProcess6020BuchenStatus !== 'pending'
    }
})

export const loadUserParamsProcess6020Buchen = createAsyncThunk('process6020BuchenSlice/loadUserParamsProcess6020Buchen', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess6020Buchen/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess6020BuchenStatus } = getState().process6020BuchenSlice
        return loadUserParamsProcess6020BuchenStatus !== 'pending'
    }
})

const Process6020BuchenSlice = createSlice({
    name: 'process6020BuchenSlice',
    initialState,
    reducers: {
        resetstartProcess6020Buchen: (state) => {
            state.job = undefined
            state.startProcess6020BuchenError = undefined
        },
        resetstartProcess6020BuchenError: (state) => {
            state.startProcess6020BuchenError = undefined
        },
        resetloadUserParamsProcess6020Buchen: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess6020BuchenError = undefined
        },
        resetloadUserParamsProcess6020BuchenError: (state) => {
            state.loadUserParamsProcess6020BuchenError = undefined
        },
        removeFromProcess6020BuchenListById: (state, action) => {
            state.process6020BuchenList = state.process6020BuchenList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess6020BuchenListByIds: (state, action) => {
            state.process6020BuchenList = state.process6020BuchenList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process6020BuchenList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess6020BuchenStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process6020BuchenList = []
            state.startProcess6020BuchenStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess6020Buchen.pending, (state) => {
            state.startProcess6020BuchenStatus = 'pending'
            state.startProcess6020BuchenError = undefined
        })
        builder.addCase(startProcess6020Buchen.fulfilled, (state, action) => {
            state.startProcess6020BuchenStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess6020Buchen.rejected, (state, action) => {
            state.startProcess6020BuchenStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess6020BuchenError = action.error.message
            } else {
                state.startProcess6020BuchenError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess6020Buchen.pending, (state) => {
            state.loadUserParamsProcess6020BuchenStatus = 'pending'
            state.loadUserParamsProcess6020BuchenError = undefined
        })
        builder.addCase(loadUserParamsProcess6020Buchen.fulfilled, (state, action) => {
            state.loadUserParamsProcess6020BuchenStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess6020Buchen.rejected, (state, action) => {
            state.loadUserParamsProcess6020BuchenStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess6020BuchenError = action.error.message
            } else {
                state.loadUserParamsProcess6020BuchenError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess6020Buchen,
    resetstartProcess6020BuchenError,
    resetloadUserParamsProcess6020Buchen,
    resetloadUserParamsProcess6020BuchenError,
    removeFromProcess6020BuchenListById,
    removeFromProcess6020BuchenListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process6020BuchenSlice.actions
export default Process6020BuchenSlice.reducer
